import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { ProductDimensionsImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DIMENSIONS_CONTRACT_DIMENSIONS
        }
        question="Can I set a custom contract duration?"
      />
    ),
    answer: (
      <div>
        No, public listings follow AWS Marketplace's standard contract duration
        options. However, you can offer custom durations when creating Private
        Offers for specific buyers.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DIMENSIONS_CONTRACT_DIMENSIONS
        }
        question="What happens if I activate pay-as-you-go pricing for additional usage?"
      />
    ),
    answer: (
      <div>
        <p>
          This allows you to charge buyers for extra usage beyond the limits of
          a specific contract dimension.
        </p>
        <p>
          <strong>Example:</strong> If you offer a plan with a flat contract fee
          but want to charge for usage exceeding a set threshold, enabling
          pay-as-you-go pricing on that dimension ensures buyers are billed for
          overages.
        </p>
      </div>
    ),
  },
]

interface FlyoutProductDimensionsContractDimensionsFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductDimensionsContractDimensionsFaqs: React.FC<
  FlyoutProductDimensionsContractDimensionsFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Contract Dimensions"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={ProductDimensionsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
